import { defineModule, } from 'direct-vuex';
import type { VerifyAnswersInput, } from '~/api/self-serve-client';

const CustomerEmailStorageKey = 'forgotEmail.currentEmail';

export interface CustomerAddress {
	city: string;
	country: string;
	houseNumber?: string;
	postcode: string;
	region?: string;
	street: string;
	supplementaryLine1?: string;
	supplementaryLine2?: string;
	supplementaryLine3?: string;
}

export interface ForgotEmail {
	currentStep: number | null;
    customerNumber: string;
	customerEmail: string;
	customerLastName: string;
    mobileDetails: {
        phoneNumber: string,
        countryCode: string,
    };
	customerAddress: CustomerAddress | null;
	questionPoolAnswers: VerifyAnswersInput;
}

export default defineModule({
	namespaced: true as const,
	state: {
		currentStep: null as (number | null),
		customerNumber: '',
		customerEmail: '',
		customerLastName: '',
		mobileDetails: {
			phoneNumber: '',
			countryCode: '',
		},
		customerAddress: null,
		questionPoolAnswers: {},
	} as ForgotEmail,
	getters: {},
	mutations: {
		setStep(state, step: ForgotEmail['currentStep']) {
			state.currentStep = step;
		},
		setCustomerEmail(state, customerEmail) {
			sessionStorage.setItem(CustomerEmailStorageKey, customerEmail);
			state.customerEmail = customerEmail;
		},
		setCustomerLastNme(state, customerLastName) {
			state.customerLastName = customerLastName;
		},
		setPhoneNumber(state, mobileDetails) {
			state.mobileDetails = { ...mobileDetails, };
		},
		setCustomerNumber(state, customerNumber) {
			state.customerNumber = customerNumber;
		},
		setCustomerAddress(state, customerAddress) {
			state.customerAddress = customerAddress;
		},
		setQuestionPoolAnswers(state, questionPoolAnswers) {
			state.questionPoolAnswers = questionPoolAnswers;
		},
		reset(state) {
			state.customerNumber = '';
			state.customerEmail = '';
			state.customerLastName = '';
			state.mobileDetails = {
				phoneNumber: '',
				countryCode: '',
			};
			state.questionPoolAnswers = {} as VerifyAnswersInput;
		},
	},
});
